import React, { memo } from 'react';
import { Navigate } from 'react-router-dom';
import { useRole } from '../context/RoleContext';
import { B } from '../utils/constants';
import { ShieldX, Home } from 'lucide-react';

function ProtectedRoute({ resourceKey, children }) {
  const { hasAccess, loading, userRole } = useRole();

  // Show loading spinner while checking permissions
  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <div
            className="w-12 h-12 border-4 border-t-transparent rounded-full animate-spin mx-auto mb-4"
            style={{ borderColor: B.forest, borderTopColor: 'transparent' }}
          />
          <p style={{ color: B.forest }}>Checking access...</p>
        </div>
      </div>
    );
  }

  // Check if user has access
  if (!hasAccess('page', resourceKey)) {
    // Show access denied message
    return (
      <div className="flex items-center justify-center h-96">
        <div className="text-center max-w-md">
          <div
            className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6"
            style={{ backgroundColor: B.rust + '15' }}
          >
            <ShieldX className="w-10 h-10" style={{ color: B.rust }} />
          </div>
          <h1 className="text-2xl font-bold mb-2" style={{ color: B.forest }}>
            Access Denied
          </h1>
          <p className="mb-6" style={{ color: B.stone }}>
            You don't have permission to access this page.
            {userRole ? (
              <span> Your current role is <strong>{userRole.name}</strong>.</span>
            ) : (
              <span> You haven't been assigned a role yet.</span>
            )}
          </p>
          <p className="text-sm mb-6" style={{ color: B.stone }}>
            Contact your administrator if you believe you should have access.
          </p>
          <a
            href="/"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-lg transition-opacity hover:opacity-80"
            style={{ backgroundColor: B.forest, color: '#fff' }}
          >
            <Home className="w-4 h-4" />
            Return to Homestead
          </a>
        </div>
      </div>
    );
  }

  return children;
}

export default memo(ProtectedRoute);
